import * as types from 'vuex-store/mutation-types'

const state = {
  device: {
    isMobile: false,
    isTablet: false
  },
  sidebar: {
    opened: false,
    hidden: false
  },
  effect: {
    translate3d: true
  },
  notifications: [],
  data_refresh_listeners: [],
  available_roles: {
    'instructor': 'instructor',
    'student': 'student'
  }
}

const mutations = {
  [types.TOGGLE_DEVICE] (state, device) {
    state.device.isMobile = device === 'mobile'
    state.device.isTablet = device === 'tablet'
  },

  [types.TOGGLE_SIDEBAR] (state, config) {
    if (state.device.isMobile && config.hasOwnProperty('opened')) {
      state.sidebar.opened = config.opened
    } else {
      state.sidebar.opened = true
    }

    if (config.hasOwnProperty('hidden')) {
      state.sidebar.hidden = config.hidden
    }
  },

  [types.SWITCH_EFFECT] (state, effectItem) {
    for (let name in effectItem) {
      state.effect[name] = effectItem[name]
    }
  },

  [types.OPEN_NOTIFICATION] (state, note) {
    state.notifications.push(note)
  },

  [types.CLEAR_NOTE_QUEUE] (state) {
    state.notifications.length = 0
  },

  [types.REGISTER_DATA_REFRESH] (state, callback) {
    state.data_refresh_listeners.push(callback)
  },

  [types.DEREGISTER_DATA_REFRESH] (state, callback) {
    state.data_refresh_listeners = state.data_refresh_listeners.filter((c) => {
      return c !== callback
    })
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./client/store/modules/app.js